export const CLINIC = {
  name: "Kalpataru Dental Care",
  phone: "+919823354121",
  phoneDisplay: "+91 98233 54121",
  address: "4, Ayachit Rd, Mangalwari, Mahal, Nagpur, Maharashtra 440032",
  mapsLink: "https://maps.app.goo.gl/G56Q4tvxeh5VqxcP8",
  mapEmbed:
    "https://www.google.com/maps?q=4%20Ayachit%20Rd%2C%20Mangalwari%2C%20Mahal%2C%20Nagpur%2C%20Maharashtra%20440032&output=embed",
  doctorPhoto:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_039b1536-753e-4303-ba31-d12a00c61066/artifacts/wluxs4n4_ChatGPT%20Image%20Aug%203%2C%202026%2C%2003_18_54%20PM.png",
  heroImage:
    "https://customer-assets-jt897jd0.emergentagent.net/job_dr-ruchika-dental/artifacts/zjl9u7no_WhatsApp%20Image%202026-08-05%20at%203.31.27%20PM%20%284%29.jpeg",
  aboutImage:
    "https://customer-assets-jt897jd0.emergentagent.net/job_dr-ruchika-dental/artifacts/937ldvhh_IMG_1786.jpeg",
};

export const CLINIC_PHOTOS = [
  {
    url: "https://customer-assets-jt897jd0.emergentagent.net/job_dr-ruchika-dental/artifacts/8hxqqv0l_WhatsApp%20Image%202026-08-03%20at%203.28.39%20PM.jpeg",
    caption: "Kalpataru Dental Care — Our Clinic",
  },
  {
    url: "https://customer-assets-jt897jd0.emergentagent.net/job_dr-ruchika-dental/artifacts/77i6ezzd_WhatsApp%20Image%202026-08-05%20at%203.31.27%20PM%20%284%29.jpeg",
    caption: "Reception & Welcome Desk",
  },
  {
    url: "https://customer-assets-jt897jd0.emergentagent.net/job_dr-ruchika-dental/artifacts/x56hyz8s_WhatsApp%20Image%202026-08-05%20at%203.31.27%20PM.jpeg",
    caption: "Modern Treatment Room",
  },
  {
    url: "https://customer-assets-jt897jd0.emergentagent.net/job_dr-ruchika-dental/artifacts/c7gtpzjd_WhatsApp%20Image%202026-08-05%20at%203.31.27%20PM%20%282%29.jpeg",
    caption: "Spacious Treatment Suite",
  },
  {
    url: "https://customer-assets-jt897jd0.emergentagent.net/job_dr-ruchika-dental/artifacts/h5v9k6ix_WhatsApp%20Image%202026-08-05%20at%203.31.27%20PM%20%283%29.jpeg",
    caption: "Advanced Dental Chair & Equipment",
  },
];


export const GALLERY = [
  {
    title: "Teeth Whitening",
    caption: "Professional whitening — brighter in one visit.",
    before: "https://images.unsplash.com/photo-1663182245833-7dd667277043?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
    after: "https://images.unsplash.com/photo-1567516364473-233c4b6fcfbe?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  },
  {
    title: "Smile Makeover",
    caption: "Aligners & veneers for a confident smile.",
    before: "https://images.unsplash.com/photo-1679911522750-aeedd9c88550?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
    after: "https://images.unsplash.com/photo-1489278353717-f64c6ee8a4d2?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  },
  {
    title: "Cosmetic Restoration",
    caption: "Crowns & bonding to restore natural beauty.",
    before: "https://images.unsplash.com/photo-1660732205495-f65510d8180e?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
    after: "https://images.unsplash.com/photo-1654373535457-383a0a4d00f9?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  },
];

export const SERVICES = [
  "Checkup",
  "Cleaning",
  "Filling",
  "Dental Implants",
  "Zirconia Crowns",
  "Laser Treatment",
  "Ortho Braces",
  "Teeth Whitening",
  "Tooth Extraction",
  "Aligners",
  "Root Canal",
  "Yearly Checkup",
];

export const HOURS = [
  { day: "Monday", open: "9:00 AM", close: "9:30 PM" },
  { day: "Tuesday", open: "9:00 AM", close: "9:30 PM" },
  { day: "Wednesday", open: "9:00 AM", close: "9:30 PM" },
  { day: "Thursday", open: "9:00 AM", close: "9:30 PM" },
  { day: "Friday", open: "9:00 AM", close: "9:30 PM" },
  { day: "Saturday", open: "9:00 AM", close: "9:30 PM" },
  { day: "Sunday", open: "1:00 PM", close: "5:00 PM" },
];

// Returns { open: boolean, label, nextInfo } based on current Nagpur (IST) time.
export function getOpenStatus() {
  const now = new Date();
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "Asia/Kolkata",
    weekday: "short",
    hour: "numeric",
    minute: "numeric",
    hour12: false,
  }).formatToParts(now);
  const map = {};
  parts.forEach((p) => (map[p.type] = p.value));
  const weekday = map.weekday; // Mon, Tue...
  const hour = parseInt(map.hour, 10) % 24;
  const minute = parseInt(map.minute, 10);
  const minutes = hour * 60 + minute;
  const isSunday = weekday === "Sun";
  const openMin = isSunday ? 13 * 60 : 9 * 60;
  const closeMin = isSunday ? 17 * 60 : 21 * 60 + 30;
  const open = minutes >= openMin && minutes < closeMin;
  return {
    open,
    label: open ? "Open Now" : "Closed",
    closesAt: isSunday ? "5:00 PM" : "9:30 PM",
  };
}
